import React from 'react';
import _ from 'lodash';
import {history} from 'store';

import I18n from 'app/common/i18n';
import {Checkbox} from 'material-ui';
import {brandColor} from 'app/theme';

import CaratIcon from 'app/assets/carat-icon.svg';
import ReportBarIcon from 'app/assets/report-bar copy.svg';

export default class Student extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			mouseOver: false,
		}
	}

	hasStudentSelected(student, selectedStudents) {
		return !!_.find(selectedStudents, _student => (_student.id === student.id))
	}

	handleCheck(student, selectedStudents) {
		let _selectedStudents;
		if(this.hasStudentSelected(student, selectedStudents)) {
			_selectedStudents = selectedStudents.filter(_student => (_student.id !== student.id));
		}
		else {
			_selectedStudents = selectedStudents.concat(student);
		}
		this.props.updateSelectedStudents(_selectedStudents);
	}

  fetchReport(student)  {
  	this.props.fetchReport(student);
    // history.push(`reports/${student}/details`);
  }

	renderStudent() {
		let {student, selectedStudents, isSelectedStudentsView, modifiedSelectedStudentList} = this.props;
		let _selectedStudents = isSelectedStudentsView ? modifiedSelectedStudentList : selectedStudents;
    let styles={
      borderBottom: '1px solid #EEE',
      color: this.hasStudentSelected(student, selectedStudents) ? brandColor : '',
      backgroundColor: this.state.mouseOver ? 'rgba(232,247,240,0.7)' : ''
    }

    return (
			<div
        className='flex p2 mx2'
        style={styles}
        onMouseEnter={() => this.setState({mouseOver: true})}
        onMouseLeave={() => this.setState({mouseOver: false})}
        onTouchTap={() => this.fetchReport(student)}>
				<div className='display-none col-1 student_selection_checkbox'>
					<Checkbox
						checked={this.hasStudentSelected(student, _selectedStudents)}
						onCheck={() => this.handleCheck(student, _selectedStudents)}/>
				</div>

				<div className='col-5'>{`${_.upperCase(student.firstName)} ${_.upperCase(student.lastName)}`}</div>
				<div className='col-1'>{student.degree.name}</div>
				<div className='col-1'>{student.department.name}</div>
				<div className='col-1'>{student.yearOfPassing}</div>
				<div className='col-1 flex items-center'>
					<div className='mr1 relative' style={{top: '0.1rem'}}><CaratIcon/></div> <div>{student.carats}</div>
				</div>
				<div className='col-2 clickable'>
					<span><ReportBarIcon /></span>
					<span className='ml2 mb1'>
						{I18n.t('candidates.detailed_report')}
					</span>
				</div>
			</div>
		);
	}

	render() {
		return (
			<div>
				{this.renderStudent()}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/candidates/Student.js